import { render, staticRenderFns } from "./WithMentions.vue?vue&type=template&id=e3dc2c00&scoped=true"
import script from "./WithMentions.vue?vue&type=script&lang=js"
export * from "./WithMentions.vue?vue&type=script&lang=js"
import style0 from "./WithMentions.vue?vue&type=style&index=0&id=e3dc2c00&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dc2c00",
  null
  
)

export default component.exports